
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxValidationRule,

} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';

//import EtapaService from '../services/etapa-service';
//import GrupoEtapaDetalleService from '../services/grupoetapadetalle-service';

import EstatusService from '../services/estatus-service';
import GrupoEstatusDetalleService from '../services/grupoestatusdetalle-service';

export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,
        DxValidationRule
    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {

            procedimientos: null,
            //dataSourceServicio: null,
            //dataSourceSolicitudServicio: null,
            dataSourceEstatus:null,
            dataSourceEstatusDetalle:null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Detalle Estatus',
                showTitle: true,
                width: 400,
                height: 300,
            },



        };
    },
    created() {

        //this.grupoetapadetalleService = new GrupoEtapaDetalleService();
        //this.etapaService = new EtapaService();
        this.estatusService = new EstatusService();
        this.grupoEstatusDetalleService = new GrupoEstatusDetalleService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: id
            });

            //this.etapaService.getEtapa().then(data => this.dataSourceServicio = data);
            //this.grupoetapadetalleService.getGrupoEtapaDetalle(myJSON).then(data => this.dataSourceSolicitudServicio = data);

            this.estatusService.getEstatus().then(data => this.dataSourceEstatus = data);
            this.grupoEstatusDetalleService.getGrupoEstatusDetalle(myJSON).then(data => this.dataSourceEstatusDetalle = data);
        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });



            this.grupoEstatusDetalleService.deleteGrupoEstatusDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha eliminado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        editRegister(e) {

            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: e.data.id,
                pgrupoestatusid: id,
                pestatusid: e.data.estatusid,
                porden: e.data.orden,
            });




            this.grupoEstatusDetalleService.updateGrupoEstatusDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha actualizado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        createRegister(e) {


            let id = this.supplierId;
            let myJSON = JSON.stringify({

                pgrupoestatusid: id,
                pestatusid: e.data.estatusid,
                porden: e.data.orden,

            });



            this.grupoEstatusDetalleService.createGrupoEstatusDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha creado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        onInitNewRow(e) {
            e.data.bactivo = true;
        },
    },
};
